// 暴露出去的接口地址
import { BaseApi, enhanceOpt } from './couplingAjax'
import vuex from '@/store/index'

import userApi from './apis/UserApi'
import Biz_api from './apis/BizApi'
import scrm_sys_api from './apis/Scrm_sys_api'
import feeApi from '@/services/apis/Fee_api'
import digital_api from '@/services/apis/Digital_api'
import MessageApi from '@/services/apis/message-api'
import IsvApi from '@/services/apis/Isv-api'
import ConfigServer from '@/services/apis/ConfigServer'

const SERVIVE = vuex.state.services

// 针对不同服务进行差异化定制
// https://172.16.103.12/user-api/doc.html#/home
const UserApi = (opt: enhanceOpt) =>
  BaseApi(opt, { prefix: SERVIVE.userApi, codeNum: 0, msgField: 'message', codeField: 'code' })

const BizApi = (opt: enhanceOpt) =>
  BaseApi(opt, { prefix: SERVIVE.bizApi, codeNum: 0, msgField: 'message', codeField: 'code' })

const Scrm_sys_api = (opt: enhanceOpt) =>
  BaseApi(opt, { prefix: SERVIVE.scrm_sys_api, codeNum: 0, msgField: 'message', codeField: 'code' })

const Fee_api = (opt: enhanceOpt) =>
  BaseApi(opt, { prefix: SERVIVE.fee_api, codeNum: 0, msgField: 'message', codeField: 'code' })

const Digital_api = (opt: enhanceOpt) =>
  BaseApi(opt, { prefix: SERVIVE.digitalApi, codeNum: 0, msgField: 'message', codeField: 'code' })

const message_api = (opt: enhanceOpt) =>
  BaseApi(opt, { prefix: SERVIVE.messageApi, codeNum: 0, msgField: 'message', codeField: 'code' })
const isv_api = (opt: enhanceOpt) =>
  BaseApi(opt, { prefix: SERVIVE.isvApi, codeNum: 0, msgField: 'message', codeField: 'code' })
const configServer = (opt: enhanceOpt) =>
  BaseApi(opt, { prefix: SERVIVE.configServer, codeNum: 0, msgField: 'message', codeField: 'code' })

export default {
  UserApi: userApi(UserApi, SERVIVE),
  Biz_api: Biz_api(BizApi, SERVIVE),
  Scrm_sys_api: scrm_sys_api(Scrm_sys_api, SERVIVE),
  Fee_api: feeApi(Fee_api, SERVIVE),
  Digital_api: digital_api(Digital_api, SERVIVE),
  MessageApi: MessageApi(message_api, SERVIVE),
  IsvApi: IsvApi(isv_api, SERVIVE),
  ConfigServer: ConfigServer(configServer, SERVIVE),
}
